module.exports = __webpack_public_path__ + "img/C@2x.be23043.webp";